module.exports = __webpack_public_path__ + "static/basics-about-update-c1cf98593b708373aa88d27223df7359.png";